import { Component, EventEmitter, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ApplicationDto, CognitoUserDto, RoleDto } from '@clearing-hub/common';
import { UserService } from '../../../service/user.service';
import { Subscription } from 'rxjs';
import { Json } from '../../../model/Json';
import { AccordionComponent } from '../../accordion/accordion.component';
import { CreateUserForm } from '../../../model/CreateUserForm';
import { CreateUserCommand } from '@clearing-hub/command';

@Component({
  selector: 'fxch-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.scss']
})
export class CreateUserComponent implements OnInit, OnDestroy {

  private subscriptions: Array<Subscription> = new Array<Subscription>();

  @ViewChild('accordionComponent') accordionComponent: AccordionComponent;
  collapsing = false;
  applicationsJson: Json<number, ApplicationDto>;
  // applicationsJson: any;
  applicationAccessesState: Json<number, boolean> = new Json<number, boolean>();
  isSubmitEnabled = true;

  userForm: FormGroup<CreateUserForm>;
  roles: Array<RoleDto>;
  applications: Array<ApplicationDto>;

  onUserCreate: EventEmitter<CognitoUserDto> = new EventEmitter<CognitoUserDto>();

  constructor(private readonly fb: FormBuilder,
              private readonly modalRef: BsModalRef,
              private readonly userService: UserService
  ) {
  }

  ngOnInit(): void {
    this.userForm = this.fb.group({
      email: new FormControl(null, [Validators.required, Validators.pattern(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)]),
      roles: this.fb.group({
        ...this.getApplicationRoles()
      }),
      attributes: this.fb.group({})
    });
    this.applicationsJson = new Json<number, ApplicationDto>(this.applications, 'id');

    this.applications.forEach(a => {
      this.applicationAccessesState[a.id] = false;
    });

    this.subscriptions.push(
      this.userForm.get('roles').valueChanges.subscribe((event) => {
        this.setIsSubmitEnabled(event);
      })
    );
  }

  create(): void {
    const command: CreateUserCommand = {
      email: this.userForm.value.email,
      attributes: Object.keys(this.userForm.value.attributes).map(k => {
        return {
          Name: k,
          Value: this.userForm.value.attributes[k]
        }
      }),
      roles: Object.fromEntries(
        Object.entries(this.userForm.value.roles)
          .filter(([key, value]) => value !== null)
      ),
    }
    this.subscriptions.push(
      this.userService.createUser(command).subscribe((user) => {
        this.onUserCreate.emit(user);
        this.modalRef.hide();
      })
    );
  }

  close(): void {
    this.modalRef.hide();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  toggleApplication(event: boolean, index: number, applicationId: string) {
    if (!event) {
      const isExpanded = this.accordionComponent.expanded.has(index);
      if (isExpanded) {
        this.accordionComponent.toggleState(index, false);
      }
      this.userForm.controls.roles.controls[applicationId].setValue(null);
    } else {
      this.accordionComponent.toggleState(index);
    }
    this.setIsSubmitEnabled();
  }

  setIsSubmitEnabled(formValue = this.userForm.value.roles) {
    this.isSubmitEnabled = Object.keys(formValue).every(a => !this.applicationAccessesState[a] || formValue[a] !== null && this.applicationAccessesState[a]);
  }

  getApplicationRoles(): Json<string, FormControl<string>> {
    const appRoles: Json<string, FormControl<string>> = new Json<number, FormControl<string>>();
    this.applications.forEach(a => {
      appRoles[a.id] = new FormControl<string>(null)
    })
    return appRoles;
  }
}
